/**
 * Resource identifiers for withResourceProtection / hasResource.
 * Sync names with login API resource_mappings when gating access.
 */
export const CONFIGURE_RESOURCE_CONTENT = 'ContentManagementPage';
export const CONFIGURE_RESOURCE_CONFIGURE_PAGE = 'Configure';
export const CONFIGURE_RESOURCE_CALENDAR = 'CalendarConfigurationPage';
export const CONFIGURE_RESOURCE_SEGMENTS = 'SegmentsConfigurationPage';
export const CONFIGURE_RESOURCE_TEMPLATE_VALUE_PREFERENCES =
  'TemplateValueConfigurationPage';
export const CONFIGURE_RESOURCE_SEGMENT_MESSAGE_TYPE_FOCUS =
  'SegmentMessageConfigurationPage';
export const CONFIGURE_RESOURCE_STATIC_VALUE_MESSAGES =
  'StaticContentConfigurationPage';
export const CONFIGURE_RESOURCE_NURTURING_JOURNEY =
  'NurturingJourneySettingsPage';
